import React from 'react'
import TopPostList from "./post/TopPostList";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav"
import ArticlePostList from "./post/ArticlePostList";
import AudioPostList from "./post/AudioPostList";
import VideoPostList from "./post/VideoPostList";
import PhotosPostList from "./post/PhotosPostList";
import LatestPostList from "./post/LatestPostList";
import { connect } from "react-redux";
import TopPostBox from './TopPostBox';
import CleverTapUtils from './commons/CleverTapUtils';
import ForumPostList from './post/ForumPostList';
import PollPostList from './post/PollPostList';
import { setProfileCompletionReminderDetails } from './reducer/profile/ProfileReducer';
import { authService } from './auth';
import * as _ from "lodash";

const feedsFilterTypes = [
    { label: "Latest", value: "LATEST" },
    { label: "Trending", value: "TOP" },
    { label: "Photos", value: "PHOTOS" },
    { label: "Videos", value: "VIDEOS" },
    { label: "Audio", value: "AUDIO" },
]

const forumAndPollFilterType = (type) => [
    { label: "Latest", value: "LATEST" },
    { label: type == "forum_1" ? "Trending" : "Completed", value: type == "forum_1" ? "TRENDING" : "COMPLETED" },
]
class PostNavbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            postCreationResponse: this.props.postCreationResponse,
            activeKey: 'top_1',
            topTabKey: 'top_1',
            latestTabKey: 'latest_1',
            photosTabKey: 'photos_1',
            videosTabKey: 'videos_1',
            articlesTabKey: 'articles_1',
            audioTabKey: 'audio_1',
            forumTabKey: 'forum_1',
            pollTabKey: 'poll_1',
            hideFlag: false,
            selectFilter: 'LATEST',
            openCompleteFlag: false
        };
    }

    componentDidMount() {
        //window.$(".posthnavtab").sticky({topSpacing: 65, responsiveWidth: true});
        var navPos = window.$('.posthnavtab').offset().top - 65;
        window.$(window).scroll(function () {
            var windscroll = window.$(window).scrollTop();
            if (windscroll >= navPos) {
                window.$('.posthnavtab').addClass('is-sticky');
            } else {
                window.$('.posthnavtab').removeClass('is-sticky');
            }
        });
        document.querySelectorAll('.nav-link').forEach(linkItem => {
            linkItem.addEventListener('click', _ => {
                window.scrollTo(0, 0)
            })
        })
        this.cleverTabData(this.state.activeKey);
    }

    cleverTabData = (activeKey) => {
        CleverTapUtils.eventClick({}, activeKey === "top_1" ? "View Latest Contents" : `View ${activeKey == "latest_1" ? "Trending" : activeKey == "photos_1" ? "photos" : activeKey == "videos_1" ? "video" : activeKey == "articles_1" ? "Articles" : "Audio"} feeds`);
    }

    componentWillReceiveProps(props) {
        if (props.postCreationResponse !== undefined) {
            let tabKey = this.state.activeKey;
            let value = tabKey.split("_");
            let tabKeyProp = value[0] + "TabKey";
            let tabKeyVal = value[0] + "_" + (parseInt(value[1]) + 1);
            this.setState({
                postCreationResponse: props.postCreationResponse,
                [tabKeyProp]: tabKeyVal,
                activeKey: tabKeyVal,
                hideFlag: props.postCreationResponse.hideFlag ? true : false
            });
        }
        if(this.state?.openCompleteFlag && props.profileCompletionReminderData?.userId) {
            this.setState({ openCompleteFlag: false })
            window.$(`#${!props.profileCompletionReminderData?.remind ? "addpostpop" : "profCompletePop"}`).modal("show");
        }
    }

    handleTabSelect = (tabKey) => {
        this.setState({
            activeKey: tabKey,
            selectFilter: "LATEST"
        });
        this.cleverTabData(tabKey);
    }

    handleChangeFilter = (tabKey) => {
        this.setState({
            selectFilter: tabKey
        })
    }

    topTabKeyChange = () => {
        this.setState({
            hideFlag: false
        })
    }

    render() {
        const feedsFilter = this.state.activeKey === "top_1" ? feedsFilterTypes : forumAndPollFilterType(this.state.activeKey);
        const currentFilter = feedsFilter && feedsFilter.find((item) => item.value === this.state.selectFilter)?.label;
        return <>
            <TopPostBox selectedTab={this.state.activeKey} />

            <Tab.Container id="left-tabs-example" onSelect={this.handleTabSelect} activeKey={this.state.activeKey}
                defaultActiveKey={this.state.topTabKey} unmountOnExit={true}>

                <div className="posthnavtab">
                    <div className="mcustHorizMenu">
                        <div className="mcustHorizinn">
                            <Nav variant="pills">
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.topTabKey || this.state.photosTabKey} title="Latest" onClick={(e) => this.topTabKeyChange()}>Post</Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                <Nav.Link eventKey={this.state.latestTabKey} title="Trending" onClick={(e) => this.topTabKeyChange()}>Trending</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey={this.state.photosTabKey} title="Photos" onClick={(e) => this.topTabKeyChange()}>Photos</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey={this.state.videosTabKey} title="Videos" onClick={(e) => this.topTabKeyChange()}>Videos</Nav.Link>
                            </Nav.Item> */}
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.articlesTabKey} title="Videos" onClick={(e) => this.topTabKeyChange()}>Articles</Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                <Nav.Link eventKey={this.state.audioTabKey} title="Audio" onClick={(e) => this.topTabKeyChange()}>Audio</Nav.Link>
                            </Nav.Item> */}
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.forumTabKey} title="Forum" onClick={(e) => this.topTabKeyChange()}>Forum</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.pollTabKey} title="Poll" onClick={(e) => this.topTabKeyChange()}>Poll</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </div>
                    <a href="javascript:void(0)" className="viewAllAct btn-primary btn" onClick={() => {this.setState({ openCompleteFlag: true }); this.props.setProfileCompletionReminderData({ userId: this.state?.userData?.userId });}}>
                        <i className="iAddPost" style={{marginRight: "5px"}} />Post
                    </a>
                </div>
                {this.state.activeKey !== "articles_1" && 
                    <div className="projtopshortby mastershorttop px-3 homeFilterBar">
                        <div className="shortwrp">
                            <span>Filter by</span>
                            <div className="shortbydrop">
                                <button type="button" className="btn dropdown-toggle" data-toggle="dropdown">{currentFilter}
                                </button>
                                <div className="dropdown-menu fadeIn animated">
                                    {feedsFilter && feedsFilter.map((data) => {
                                        return (
                                            data.value !== this.state.selectFilter && <a className="dropdown-item" id="filter-Forum" onClick={e => { this.handleChangeFilter(data.value)}}>{data.label}</a>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Tab.Content>
                    <Tab.Pane eventKey={this.state.topTabKey}>
                        <LatestPostList key={this.state.topTabKey} hideFlag={this.state.hideFlag} filterData={this.state.selectFilter} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.latestTabKey}>
                        <TopPostList key={this.state.latestTabKey} hideFlag={this.state.hideFlag} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.photosTabKey}>
                        <PhotosPostList key={this.state.photosTabKey} hideFlag={this.state.hideFlag} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.videosTabKey}>
                        <VideoPostList key={this.state.videosTabKey} hideFlag={this.state.hideFlag} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.articlesTabKey}>
                        <ArticlePostList key={this.state.articlesTabKey} hideFlag={this.state.hideFlag} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.audioTabKey}>
                        <AudioPostList key={this.state.audioTabKey} hideFlag={this.state.hideFlag} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.forumTabKey}>
                        <ForumPostList key={this.state.forumTabKey} hideFlag={this.state.hideFlag} filterData={this.state.selectFilter} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.pollTabKey}>
                        <PollPostList key={this.state.pollTabKey} hideFlag={this.state.hideFlag} filterData={this.state.selectFilter} />
                    </Tab.Pane>
                </Tab.Content>

            </Tab.Container>
        </>

    }
}


const mapStateToProps = (state) => {
    return {
        postCreationResponse:
            state.postReducer &&
            state.postReducer.postCreationResult.value,
        profileCompletionReminderData:  state.ProfileReducer?.profileCompletionReminderData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setProfileCompletionReminderData: (state) => dispatch(setProfileCompletionReminderDetails(state))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostNavbar);
